import { Component } from '@angular/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ToastService } from '../../../shared/services/toast.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';
import { DialogCadastroCompletoComponent } from './dialog-cadastro-completo/dialog-cadastro-completo.component';
import { DialogCadastroParcialComponent } from './dialog-cadastro-parcial/dialog-cadastro-parcial.component';

@Component({
  selector: 'app-cadastro-motorista',
  imports: [ButtonComponent],
  templateUrl: './cadastro-motorista.component.html',
  styleUrl: './cadastro-motorista.component.scss',
})
export class CadastroMotoristaComponent {
  constructor(
    private toast: ToastService,
    private dialog: MatDialog,
  ) {}

  partial_registration() {
    const dialogRef = this.dialog.open(DialogCadastroParcialComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Motorista registrado!');
      }
    });
  }

  full_registration() {
    const dialogRef = this.dialog.open(DialogCadastroCompletoComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Motorista registrado!');
      }
    });
  }
}
